class ServiceBase {
  constructor(dataReq, error, { validation } = {}) {
    if (!dataReq) {
      throw new Error(`${this.constructor.name} no request given`);
    }
    if (!error) {
      throw new Error(`${this.constructor.name} no error function given`);
    }
    this.dataReq = dataReq;
    this.error = error;
    this.#validation = validation ?? {};
  }

  get(...args) {
    return this.dataReq.get(...args);
  }

  checklistRequest(...args) {
    return this.moduleRequest('checklist', ...args);
  }

  locationRequest(...args) {
    return this.moduleRequest('location', ...args);
  }

  menuRequest(...args) {
    return this.moduleRequest('menu', ...args);
  }

  reviewRequest(...args) {
    return this.moduleRequest('review', ...args);
  }

  serviceRequest(...args) {
    return this.moduleRequest('service', ...args);
  }

  tripRequest(...args) {
    return this.moduleRequest('trip', ...args);
  }

  shareRequest(...args) {
    return this.moduleRequest('share', ...args);
  }

  weatherRequest(...args) {
    return this.moduleRequest('weather', ...args);
  }

  moduleRequest(module, action, data, defaultValue) {
    const schema = this.getSchema({ module, action });
    let validatedData = this.validate(schema, data);
    return (
      validatedData &&
      this.dataReq.request(
        Object.assign(
          {
            module,
            action,
          },
          validatedData
        ),
        defaultValue
      )
    );
  }

  requestPath(path, data) {
    const schema = this.getSchema({ action: path.substring(1) });
    let validatedData = this.validate(schema, data);
    return (
      validatedData && this.dataReq.apiRequest(path, 'POST', validatedData)
    );
  }

  validate(schema, data) {
    if (this.#validation.disabled) {
      return data ?? {};
    }

    if (!schema) {
      this.error(`No schema to validate ${JSON.stringify(data)}`);
      return null;
    }

    try {
      let validatedData = schema.validate(data);
      if (this.#validation.testingMode) {
        // Do not cut unexpected properties in testing.
        for (let prop in validatedData) {
          data[prop] = validatedData[prop];
        }
        return data ?? {};
      }
      return validatedData;
    } catch (e) {
      this.error(e);
      return null;
    }
  }

  #validation;
}

export { ServiceBase };
